import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    color: {
        id: "tasks.barSorting.color",
    },
});

export default messages;
